import { __assign } from "tslib";
export { getFinalStyle };
function getFinalStyle(_a) {
    var isNewInfoElements = _a.isNewInfoElements, shouldControlHorizontalAlignment = _a.shouldControlHorizontalAlignment, style = _a.style, horizontalAlignment = _a.horizontalAlignment, paddingBottom = _a.paddingBottom, paddingTop = _a.paddingTop, paddingRight = _a.paddingRight, paddingLeft = _a.paddingLeft;
    var newInfoStyle = __assign(__assign({}, style), { 
        // paddingBottom: `${paddingBottom}px`,
        // paddingTop: `${paddingTop}px`,
        // paddingRight: `${paddingRight}px`,
        // paddingLeft: `${paddingLeft}px`,
        textAlign: horizontalAlignment });
    if (shouldControlHorizontalAlignment === false) {
        delete newInfoStyle.textAlign;
    }
    return isNewInfoElements ? newInfoStyle : style || {};
}
//# sourceMappingURL=sharedBetweenInfoComponents.js.map